import { Link as RouterLink } from 'react-router-dom';
import type { ColumnDef } from '@tanstack/react-table';

import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

import type { ProductTypeOption } from 'containers/admin/products/product/product-form';

export interface ProductRow {
  id: string | number;
  name?: string;
  description?: string;
  type?: string;
  [key: string]: unknown;
}

const commonStyles = 'pl-4 border-r-2 border-white font-semibold';

export const getProductsTableSettings = (
  productDictionary: ProductTypeOption[]
): ColumnDef<ProductRow>[] => [
  {
    id: 'name',
    accessorKey: 'name',
    header: () => <span>PRODUCT NAME</span>,
    cell: (info) => info.renderValue(),
    headerClassName: `${commonStyles} cursor-pointer rounded-tl-md rounded-bl-md`,
    className: 'pl-4 tablet:w-[25%] sm:w-[30%] font-semibold',
    enableSorting: true,
    sortingFn: 'alphanumeric',
  } as ColumnDef<ProductRow>,
  {
    id: 'description',
    accessorKey: 'description',
    header: () => <span>PRODUCT DESCRIPTION</span>,
    cell: (info) => <span>{info.renderValue() as React.ReactNode}</span>,
    headerClassName: `${commonStyles} cursor-context-menu`,
    className: 'pl-4 tablet:w-[30%] sm:w-[35%] lg:w-[45%]',
    enableSorting: false,
  } as ColumnDef<ProductRow>,
  {
    id: 'type',
    accessorKey: 'type',
    header: () => <span>PRODUCT TYPE</span>,
    cell: (info) => {
      const category = info.getValue() as string | undefined;

      const associatedProduct = productDictionary?.find(
        (el) => el.name === category
      );

      return associatedProduct ? (
        <span>{associatedProduct.description}</span>
      ) : (
        <span className="text-gray-500">Not assigned</span>
      );
    },
    headerClassName: `${commonStyles} cursor-pointer`,
    className: 'pl-4 tablet:w-[25%] sm:w-[15%]',
    enableSorting: true,
  } as ColumnDef<ProductRow>,

  {
    id: 'button-cell',
    cell: ({
      row: {
        original: { id },
      },
    }) => (
      <RouterLink to={`/admin/products/${id}`}>
        <Button
          variant="reserve-outlined"
          size="sm"
          iconBefore={<Icons.Eye aria-label="EyeIcon" />}
          className="text-xs md:text-sm"
        >
          View Details
        </Button>
      </RouterLink>
    ),
    headerClassName: 'h-12 rounded-tr-md rounded-br-md',
    className: 'py-3',
  } as ColumnDef<ProductRow>,
];
